module.exports = __webpack_public_path__ + "media/images/Ligne-gray-32c44aca.png";